import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { FormControl } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { debounceTime, distinctUntilChanged, startWith } from "rxjs/operators";
import { DemoService } from "../demo.service";
import { CalendarService } from "src/app/pages/calendar/calendar.service";
import icSearch from "@iconify/icons-ic/twotone-search";
@Component({
  selector: 'vex-body-parts',
  templateUrl: './body-parts.component.html',
  styleUrls: ['./body-parts.component.scss']
})
export class BodyPartsComponent {
  isLoading = false; // Spinner loading state
  bodyParts = {
    leftSide: [],
    rightSide: [],
    bilateralSide: [],
    unspecifiedSide: [],
  };

  bodyParts2 = [
    { name: "Neck", side: "All" },
    { name: "Cervical Spine", side: "All" },
    { name: "Upper Extremity (Right)", side: "all" },
    { name: "Upper Extremity (Left)", side: "all" },
    { name: "Upper Extremity (Bilateral)", side: "all" },
    { name: "Upper Extremity (Unspecified)", side: "all" },
    { name: "Shoulder (Right)", side: "all" },
    { name: "Shoulder (Left)", side: "all" },
    { name: "Shoulder (Bilateral)", side: "all" },
    { name: "Shoulder (Unspecified)", side: "all" },
    { name: "Arm (Right)", side: "all" },
    { name: "Arm (Left)", side: "all" },
    { name: "Arm (Bilateral)", side: "all" },
    { name: "Arm (Unspecified)", side: "all" },
    { name: "Elbow (Right)", side: "all" },
    { name: "Elbow (Left)", side: "all" },
    { name: "Elbow (Bilateral)", side: "all" },
    { name: "Elbow (Unspecified)", side: "all" },
    { name: "Forearm (Right)", side: "all" },
    { name: "Forearm (Left)", side: "all" },
    { name: "Forearm (Bilateral)", side: "all" },
    { name: "Forearm (Unspecified)", side: "all" },
    { name: "Wrist (Right)", side: "all" },
    { name: "Wrist (Left)", side: "all" },
    { name: "Wrist (Bilateral)", side: "all" },
    { name: "Wrist (Unspecified)", side: "all" },
    { name: "Hand (Right)", side: "all" },
    { name: "Hand (Left)", side: "all" },
    { name: "Hand (Bilateral)", side: "all" },
    { name: "Hand (Unspecified)", side: "all" },
    { name: "Finger (Right)", side: "all" },
    { name: "Finger (Left)", side: "all" },
    { name: "Finger (Bilateral)", side: "all" },
    { name: "Finger (Unspecified)", side: "all" },
    { name: "Thumb (Right)", side: "all" },
    { name: "Thumb (Left)", side: "all" },
    { name: "Thumb (Bilateral)", side: "all" },
    { name: "Thumb (Unspecified)", side: "all" },
    { name: "Index Finger (Right)", side: "all" },
    { name: "Index Finger (Left)", side: "all" },
    { name: "Index Finger (Bilateral)", side: "all" },
    { name: "Index Finger (Unspecified)", side: "all" },
    { name: "Middle (Long) Finger (Right)", side: "all" },
    { name: "Middle (Long) Finger (Left)", side: "all" },
    { name: "Middle (Long) Finger (Bilateral)", side: "all" },
    { name: "Middle (Long) Finger (Unspecified)", side: "all" },
    { name: "Ring Finger (Right)", side: "all" },
    { name: "Ring Finger (Left)", side: "all" },
    { name: "Ring Finger (Bilateral)", side: "all" },
    { name: "Ring Finger (Unspecified)", side: "all" },
    { name: "Small Finger (Right)", side: "all" },
    { name: "Small Finger (Left)", side: "all" },
    { name: "Small Finger (Bilateral)", side: "all" },
    { name: "Small Finger (Unspecified)", side: "all" },
    { name: "Thoracic Spine", side: "all" },
    { name: "Upper back", side: "all" },
    { name: "Back", side: "all" },
    { name: "Lumbar Spine", side: "all" },
    { name: "Lower Extremity (Right)", side: "all" },
    { name: "Lower Extremity (Left)", side: "all" },
    { name: "Lower Extremity (Bilateral)", side: "all" },
    { name: "Lower Extremity (Unspecified)", side: "all" },
    { name: "Hip (Right)", side: "all" },
    { name: "Hip (Left)", side: "all" },
    { name: "Hip (Bilateral)", side: "all" },
    { name: "Hip (Unspecified)", side: "all" },
    { name: "Buttock (Right)", side: "all" },
    { name: "Buttock (Left)", side: "all" },
    { name: "Buttock (Bilateral)", side: "all" },
    { name: "Buttock (Unspecified)", side: "all" },
    { name: "Thigh (Right)", side: "all" },
    { name: "Thigh (Left)", side: "all" },
    { name: "Thigh (Bilateral)", side: "all" },
    { name: "Thigh (Unspecified)", side: "all" },
    { name: "Knee (Right)", side: "all" },
    { name: "Knee (Left)", side: "all" },
    { name: "Knee (Bilateral)", side: "all" },
    { name: "Knee (Unspecified)", side: "all" },
    { name: "Leg (Right)", side: "all" },
    { name: "Leg (Left)", side: "all" },
    { name: "Leg (Bilateral)", side: "all" },
    { name: "Leg (Unspecified)", side: "all" },
    { name: "Ankle (Right)", side: "all" },
    { name: "Ankle (Left)", side: "all" },
    { name: "Ankle (Bilateral)", side: "all" },
    { name: "Ankle (Unspecified)", side: "all" },
    { name: "Foot (Right)", side: "all" },
    { name: "Foot (Left)", side: "all" },
    { name: "Foot (Bilateral)", side: "all" },
    { name: "Foot (Unspecified)", side: "all" },
    { name: "Toes (Right)", side: "all" },
    { name: "Toes (Left)", side: "all" },
    { name: "Toes (Bilateral)", side: "all" },
    { name: "Toes (Unspecified)", side: "all" },
  ];
  selectedParts = new Set<string>();
  selectedTab: string = "all";
  searchControl = new FormControl();
  filteredParts: string[] = [];
  selectedFilter: string = "Orthopedics";
  icSearch = icSearch;
  allBodyParts: any;
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<BodyPartsComponent>,
    private toastr: ToastrService,
    private service: DemoService
  ) {}

  ngOnInit(): void {
    this.updateFilteredParts();

    this.searchControl.valueChanges
    .pipe(debounceTime(300), distinctUntilChanged(), startWith(""))
    .subscribe((query) => {
      this.updateFilteredParts(query);
    });

    this.fetchBodyParts(this.selectedFilter);
  }

  //   updateFilteredParts(query: string = ""): void {
  //     const lowercaseQuery = query ? query.toLowerCase() : "";

  //     const parts = this.getPartsByTab();
  //     this.filteredParts = parts
  //       .filter((part) => part && part.name && part.side && part.side.toLowerCase().includes(lowercaseQuery))
  //       .map((part) => `${part.name} (${part.side})`);
  // }

  updateFilteredParts(query: string = ""): void {
    const parts = this.getPartsByTab();

    if (!parts || !Array.isArray(parts)) {
      this.filteredParts = [];
      return;
    }
    const lowercaseQuery = query.toLowerCase();
  
    this.filteredParts = parts
      .filter((part) => {
        if (!part || !part.name) return false;
  
        const matchesQuery =
          part.name.toLowerCase().includes(lowercaseQuery) ||
          (part.side?.toLowerCase?.().includes(lowercaseQuery) ?? false);
  
        const matchesTab =
          this.selectedTab === 'all' ||
          (part.side?.toLowerCase?.() === this.selectedTab.toLowerCase());
  
        return matchesQuery && matchesTab;
      })
      .map((part) => {
        const sideLabel = part.side ? `${part.side} ` : '';
        return `${sideLabel}${part.name}`;
      });
  }

  clearSearch(): void {
    this.searchControl.setValue("");
  }


  fetchBodyParts(filter: string = "") {
    this.isLoading = true;
    this.service.getAllBodyParts(filter).subscribe(
      (response) => {
        this.bodyParts = response.data;
        this.allBodyParts = response.allSides;
        this.updateFilteredParts();
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  getPartsByTab(): any[] {
    if (!this.bodyParts) {
      return [];
    }
  
    switch (this.selectedTab) {
      case "Right":
        return this.bodyParts.rightSide || [];
      case "Left":
        return this.bodyParts.leftSide || [];
      case "Bilateral":
        return this.bodyParts.bilateralSide || [];
      case "Unspecified":
        return this.bodyParts.unspecifiedSide || [];
      case "all":
        return this.allBodyParts || []; // 🔁 fix here
      default:
        return [];
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close(this.selectedParts);
  }


  toggleSelection(part: string) {
    if (this.selectedParts.has(part)) {
      this.selectedParts.delete(part);
    } else {
      this.selectedParts.add(part);
    }
  }

  isSelected(part: string): boolean {
    // console.log(part, "selected")
    return this.selectedParts.has(part);
  }


  selectTab(tab: string): void {
    this.selectedTab = tab;
  
    // Don't pass tab name as search query!
    this.updateFilteredParts(this.searchControl.value || ""); 
  }

  applyFilter(filter: string): void {
    this.selectedFilter = filter;
    this.fetchBodyParts(filter);
  }


  getPartsForColumn(column: number): string[] {
    const totalParts = this.filteredParts.length;
    const partsPerColumn = Math.ceil(totalParts / 3);
    const start = (column - 1) * partsPerColumn;
    const end = start + partsPerColumn;
    return this.filteredParts.slice(start, end);
  }
}
